<template>
	<div :class="$style.errorsInApp">
		<div :class="$style.container">
			<div
				class="pl-5 pr-5 pt-5 pb-5 text-dark font-size-30"
				:class="$style.info"
			>
				<div class="font-weight-bold mb-3">
					🚧 Acceso denegado
				</div>
				<div>
					Actualmente no dispones de acceso para este recurso.
					Si crees que se trata de un error contacta con soporte.
				</div>
				<div class="font-weight-bold font-size-70">
					403 —
				</div>
			</div>
			<span
				:class="[$style.bgEmoji, $style.bgEmojiRotate]"
				:style="{}"
			>⛔</span>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Error403'
};
</script>
<style lang="scss" module>
@import './style.scss';
</style>
